/** 사업자 정보 — 푸터·이용약관·개인정보 처리방침에서 공용으로 사용. */
export const COMPANY = {
  serviceName: "Stayline",
  name: "주식회사 디체인커넥트",
  ceo: "오미숙",
  bizRegNo: "463-81-02611",
  ecommerceRegNo: "제2022-서울서초-1328호",
  address: "서울특별시 서초구 서초중앙로 200, 10동 505호(서초동, 삼풍아파트)",
  email: "contact@dchain-connect.com",
  phone: "02-592-2129",
  privacyOfficer: "오미숙 (대표)",
  privacyContact: "contact@dchain-connect.com",
  termsEffectiveDate: "2026년 7월 9일",
  privacyEffectiveDate: "2026년 7월 9일",
} as const;
